import { domContentLoaded } from '@flowio/browser-helpers';
import { isNil, isString } from '@flowio/is';
import { TaskQueue } from '@flowio/task-queue';
import appendQueryParameters from './appendQueryParameters';
import createFrame from './createFrame';
import createObserver from './createObserver';
import getLocation from './getLocation';
import resolveUrl from './resolveUrl';
import uniqueId from './uniqueId';
export default function createConsumer(config) {
  var targetWindow = null;
  var frame = null;
  var observer = createObserver();
  var queue = new TaskQueue();
  var remote = config.remote,
      _config$channel = config.channel,
      channel = _config$channel === void 0 ? 'default' : _config$channel,
      _config$container = config.container,
      container = _config$container === void 0 ? document.body : _config$container;
  var channelId = "".concat(channel).concat(uniqueId());
  var targetOrigin = getLocation(remote);

  function subscribe(subscriber) {
    return observer.subscribe(subscriber);
  }

  function postMessage(message) {
    queue.insert(function () {
      if (!isNil(targetWindow)) {
        targetWindow.postMessage("".concat(channelId, " ").concat(JSON.stringify(message)), targetOrigin);
      }
    });
  }

  function receiveMessage(event) {
    var origin = getLocation(event.origin);

    if (origin === targetOrigin && isString(event.data) && event.data.substring(0, channelId.length + 1) === "".concat(channelId, " ")) {
      var message = event.data.substring(channelId.length + 1);
      var action = JSON.parse(message);
      observer.notify(action);
    }
  }

  function waitForReady(event) {
    if (isNil(frame)) {
      throw new Error('Ready message received before frame element was created');
    }

    if (event.data === "".concat(channelId, "-ready")) {
      targetWindow = frame.contentWindow;
      window.removeEventListener('message', waitForReady);
      window.addEventListener('message', receiveMessage);
      queue.ready();
    }
  }

  function destroy() {
    window.removeEventListener('message', waitForReady);
    window.removeEventListener('message', receiveMessage);

    if (!isNil(frame)) {
      if (!isNil(frame.parentNode)) {
        frame.parentNode.removeChild(frame);
      }

      targetWindow = null;
      frame = null;
    }
  }

  domContentLoaded(function () {
    window.addEventListener('message', waitForReady);
    frame = createFrame({
      container: container,
      name: "".concat(channelId, "_provider"),
      source: appendQueryParameters(resolveUrl(remote), {
        origin: getLocation(window.location.href),
        channelId: channelId
      }),
      style: config.style
    });
  });
  return {
    subscribe: subscribe,
    postMessage: postMessage,
    destroy: destroy
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/postmessage/lib/esm/createConsumer.js
// module id = 648
// module chunks = 0 1